import { Fragment, useCallback, useEffect, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { ProfilesCrumbs } from '../constants';
import ProfileForm, { FormProfile } from 'system/components/profiles/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useNavigate, useParams } from 'react-router';
import { HttpResponse } from 'shell/models/http-response';
import { Profile } from 'shell/models/profile';
import { toast } from 'react-toastify';

const ProfilesEditPage = (): React.ReactElement => {
  const params = useParams();
  const { put: updateProfile } = useHttpFetch(`${__MANAGEMENT_API_URL__}/profili/${params.id}`);

  const {
    get: getProfile,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Profile>>(`${__MANAGEMENT_API_URL__}/profili/${params.id}`);

  useEffect(() => {
    getProfile();
  }, []);

  const profile: FormProfile = useMemo(() => {
    const profilePayload = data?.payload;
    if (!profilePayload || !!error) {
      return {};
    }
    return {
      code: profilePayload.key?.codice?.toString() || '',
      name: profilePayload.nome,
      lastUpdate: profilePayload.note,
      functionalities: profilePayload.funzioni?.map((element) => ({
        id: element.key.codice.toString(),
        institutionCode: element.codiceEnte,
        description: element.nome,
        entity: element.entita,
        event: element.evento,
        checked: true,
      })),
      groups: profilePayload.gruppi?.map((element) => ({
        id: element.key.codice.toString(),
        description: element.nome,
        institutionCode: element.codiceEnte,
        checked: false,
      })),
    };
  }, [data, error]);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues?: FormProfile) => {
      updateProfile({
        nome: formValues?.name,
        note: formValues?.lastUpdate,
        funzioni: formValues?.functionalities?.map((element) => ({
          key: {
            codice: element.id,
          },
          codiceEnte: element.institutionCode,
          entita: element.entity,
          evento: element.event,
          nome: element.description,
        })),
        gruppi: formValues?.groups?.map((element) => ({
          key: {
            codice: element.id,
          },
          codiceEnte: element.institutionCode,
          nome: element.description,
        })),
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/profili');
      });
    },
    [updateProfile, navigate]
  );
  return (
    <Fragment>
      <Breadcrumbs items={[...ProfilesCrumbs, { name: 'Modifica Profilo' }]} />
      {!loading && data ? (
        <ProfileForm
          title="Modifica Profilo"
          onOk={onSubmit}
          insert
          onCancel={() => {
            navigate('/sistema/profili');
          }}
          initialValues={profile}
        />
      ) : undefined}
    </Fragment>
  );
};

ProfilesEditPage.displayName = 'Profiles edit page component';

export default ProfilesEditPage;
